module.exports = __webpack_public_path__ + "static/week_week6_spot1-6e7e81ff2c9c82c686cef083c6e5c5e4.jpg";